import { observer } from "mobx-react-lite";
import { MDSButton, MDSButtonIcon, MDSButtonSlotName } from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";
import { MdsTooltip, MdsTooltipPlacement } from "@/design-system/components/tooltip";

interface NoteVersionRestoreButtonProps {
  onRestore: () => void;
  isEnabled: boolean;
  isLoading?: boolean;
  versionLabel: string;
}

export const NoteVersionRestoreButton = observer<NoteVersionRestoreButtonProps>(
  function NoteVersionRestoreButton({ onRestore, isEnabled, isLoading, versionLabel }) {
    const button = (
      <MDSButton onClick={onRestore} isDisabled={!isEnabled} isLoading={isLoading}>
        <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.History} />
        Restore {versionLabel}
      </MDSButton>
    );

    if (!isEnabled) {
      return (
        <MdsTooltip
          config={{
            label: "This is the latest version already",
            placement: MdsTooltipPlacement.Top,
          }}
        >
          {button}
        </MdsTooltip>
      );
    }

    return button;
  }
);
